// @owners { team: patient-health }
import { PressableAltoIcon, Row, SmPadding, XxsSpacing } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { Button, Text } from '@alto/pocky';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { type User } from '~shared/types/clients';
import Image from '~web/components/Image';
import { SingleColumnContentWrapper } from '~web/components/Page';
import EmptyStateBox, { CenteredH1 } from '~web/features/app/components/EmptyStateBox';
import prescriptions from '~web/images/prescriptions@2x.png';

type Props = {
  openSendPrescriptionOptions: () => void;
  openFAQs: () => void;
  user?: User;
};

const CenteredButton = styled(Button)`
  justify-content: center;
  align-self: center;
`;

const CenteredText = styled(Text)`
  text-align: center;
`;

export default class MyMedsEmpty extends React.PureComponent<Props> {
  static propTypes = {
    openSendPrescriptionOptions: PropTypes.func.isRequired,
    openFAQs: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  render() {
    const { openSendPrescriptionOptions, user, openFAQs } = this.props;
    const name = user?.preferred_first_name || user?.first_name;
    const greeting = name ? `Welcome to Alto Pharmacy, ${name}!` : 'Welcome to Alto Pharmacy!';

    return (
      <SingleColumnContentWrapper>
        <CenteredH1 announceToScreenReader>{greeting}</CenteredH1>
        <EmptyStateBox>
          <Text>
            You don&#39;t have any active prescriptions. We&#39;ll notify you as soon as we receive a new prescription
            for you.
          </Text>
          <Text>
            If you&#39;re waiting on a prescription from your doctor, please allow up to an hour for it to appear here.
          </Text>
        </EmptyStateBox>
        <EmptyStateBox center>
          <Image
            alt={IMG_ALT_TEXTS.prescriptions}
            src={prescriptions}
            sidebar
          />
          <Text>Send a prescription to Alto.</Text>
          <CenteredButton onClick={openSendPrescriptionOptions}>Learn more</CenteredButton>
        </EmptyStateBox>
        <SmPadding>
          <Row
            center
            wrap
          >
            <CenteredText
              small
              light
            >
              Why can&#39;t I see my prescription?
            </CenteredText>
            <XxsSpacing />
            <PressableAltoIcon
              name="info-small"
              onPress={openFAQs}
              accessibilityLabel="Press to view frequently asked questions"
            />
          </Row>
        </SmPadding>
      </SingleColumnContentWrapper>
    );
  }
}
